import EmbeddingEventSnippet from "../../../../contents/docs/llm-analytics/_snippets/embedding-event.mdx";
import * as React from 'react';
export default {
  EmbeddingEventSnippet,
  React
};